/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {TableHealth, ShadowTableColumn} from './styles';

export default ({
  dataTableContent,

  dataCy,
}: {
  dataTableContent: Array<any>;

  dataCy?: string;
}) => {
  const [table, useTable] = useState<Array<any>>(dataTableContent);

  useEffect(() => {
    useTable(dataTableContent);
  }, [dataTableContent]);

  return (
    <TableHealth data-cy={dataCy}>
      <thead>
        <tr>
          <th></th>
          <th colSpan={7}>WELLNESS</th>
          <th colSpan={9}>ACCOUNTABILITY</th>
        </tr>
        <tr>
          <th>ALERTS</th>
          <th colSpan={3}>ARM</th>
          <th colSpan={2}>BODY</th>
          <th colSpan={2}>SLEEP</th>
          <th colSpan={5}>ARM CARE</th>
          <th colSpan={4}>EXAMS</th>
        </tr>
        <tr>
          <th></th>

          <th>
            <span>Last</span>
          </th>

          <th>
            <span>Location</span>
          </th>
          <th>
            <span>7 Day Avg</span>
          </th>
          <th>
            <span>Last</span>
          </th>

          <th>
            <span>7 Day Avg</span>
          </th>
          <th>
            <span>Last</span>
          </th>

          <th>
            <span>7 Day Avg</span>
          </th>
          <th>
            <span>Custom Arm Care</span>
          </th>
          <th>
            <span>Current Streak</span>
          </th>
          <th>
            <span>Last 7 Days</span>
          </th>

          <th>
            <span>Longest Streak</span>
          </th>
          <th>
            <span>Total Sessions</span>
          </th>
          <th>
            <span>Last</span>
          </th>
          <th>
            <span>Next</span>
          </th>
          <th>
            <span>Last 30 Days</span>
          </th>
          <th>
            <span>Total Exams</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {table?.length > 0 ? (
          table?.map((item, index) => {
            return (
              <tr key={index}>
                <td> </td>
                <ShadowTableColumn></ShadowTableColumn>
                <ShadowTableColumn></ShadowTableColumn>
                <ShadowTableColumn></ShadowTableColumn>
                <td></td>
                <td></td>
                <ShadowTableColumn></ShadowTableColumn>
                <ShadowTableColumn></ShadowTableColumn>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <ShadowTableColumn></ShadowTableColumn>
                <ShadowTableColumn></ShadowTableColumn>
                <ShadowTableColumn></ShadowTableColumn>
                <ShadowTableColumn></ShadowTableColumn>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={17}>No Data</td>
          </tr>
        )}
      </tbody>
    </TableHealth>
  );
};
